import { createSelector } from 'reselect';
import { clientOnlyChild } from './clients';

const slice = (state) => state.comptePoids || {};

export const selectComptePoidsItems = createSelector([slice], (s) => s.items || []);
export const selectComptePoidsFilter = createSelector([slice], (s) => s.filterClientId || null);
export const selectComptePoidsDateDebut = createSelector([slice], (s) => s.dateDebut || null);
export const selectComptePoidsDatFin = createSelector([slice], (s) => s.dateFin || null);
export const selectComptePoidsLoading = createSelector([slice], (s) => !!s.loading);
export const selectComptePoidsPosting = createSelector([slice], (s) => !!s.posting);
export const selectComptePoidsError = createSelector([slice], (s) => s.error || null);
export const selectComptePoidsLastUpdated = createSelector([slice], (s) => s.lastUpdated || null);

export const selectFilteredComptePoidsItems = createSelector(
  [selectComptePoidsItems, selectComptePoidsFilter],
  (items, filterClientId) => {
    if (!filterClientId) return items;
    return items.filter(i => String(i.clientId) === String(filterClientId));
  }
);

export const selectComptePoidsTotal = createSelector(
  [selectFilteredComptePoidsItems],
  (items) => items.reduce((sum, item) => {
    const ancienSolde = Number(item.ancienSolde) || 0;
    const soldePeriode = Number(item.solde750) || 0;
    const perteCumulee = Number(item.perteCumulee) || 0;
    return sum + ancienSolde + soldePeriode + perteCumulee;
  }, 0)
);

export const selectClientsForComptePoids = createSelector(
  [clientOnlyChild],
  (clients) => (clients || []).map(c => {
    const cid = c.id ?? c.client_id ?? c.cli_id;
    const label = c.raison_soc || c.nom || c.name || c.label || `Client ${cid || ''}`;
    return { id: cid, label };
  }).sort((a, b) => (a.label || '').localeCompare(b.label || ''))
);

export const selectComptePoidsStatus = createSelector(
  [selectComptePoidsLoading, selectComptePoidsPosting, selectComptePoidsError, selectComptePoidsLastUpdated],
  (loading, posting, error, lastUpdated) => ({ loading, posting, error, lastUpdated })
);
